<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs2>
              <div class="x-text-field">
                <label>排序</label>
                <div>{{item.rank}}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>姓名</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs7>
              <div class="x-text-field">
                <label>单位名称</label>
                <div>{{item.deptName}}</div>
              </div>
            </v-flex>

            <v-flex xs2>
              <div class="x-text-field">
                <label>性别</label>
                <div>{{item.sex}}</div>
              </div>
            </v-flex>

            <v-flex xs2>
              <div class="x-text-field">
                <label>年龄</label>
                <div>{{item.age}}</div>
              </div>
            </v-flex>

            <v-flex xs4>
              <div class="x-text-field">
                <label>职称</label>
                <div>{{item.title? item.title.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs4>
              <div class="x-text-field">
                <label>学位</label>
                <div>{{item.education? item.education.name : ''}}</div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseURI = '/api/proj/member';

  export default {
    mixins: [mixin.view(baseURI)],

    data() {
      return {
        item: {}
      }
    }
  }
</script>
